export interface TableField<T = object> {
  key: keyof T | string;
  label: string;
  formatter?: (item: T) => string;
}
